<h2 mat-dialog-title>
  SELECT PLAYERS
</h2>

<div mat-dialog-content >

  <mat-selection-list #playerlist style="height: 350px; " [multiple]="true" >
    @for (team of this.teams; track team) {
      @if (team.Players.length>0) {
        <mat-divider></mat-divider>
      }
      @if (team.Players.length>0) {
        <label >{{team.team.LevelName}}</label>
        }<br/>
        @for (player of team.Players; track player) {
          <mat-list-option style="height: 40px;" [value]="player.Player" >
            <h4 mat-line>{{player.Player.LastName}}, {{player.Player.FirstName}}</h4>
            <span mat-line>{{player.Player.DateOfBirth | date:'yyyy-MM-dd'}}</span>
          </mat-list-option>
        }
      }
    </mat-selection-list>

  </div>

  <div mat-dialog-actions>

    <button mat-button [mat-dialog-close]="playerlist.selectedOptions?.selected" cdkFocusInitial >SELECT</button>
    <button mat-button [mat-dialog-close]="false" >CANCEL</button>


  </div>
